import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { ReactNode } from 'react';
import { Cross } from './icons';

export interface SidePanelProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  width?: number;
}

export function SidePanel({ open, title, onClose, children, width = 480 }: SidePanelProps) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width, maxWidth: '100vw', p: 3, boxSizing: 'border-box' } }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h3">{title}</Typography>
        <IconButton onClick={onClose} aria-label="close">
          <Cross sx={{ width: 16, height: 16, color: '#97A2AA' }} />
        </IconButton>
      </Box>
      <Box sx={{ overflowY: 'auto', flex: 1 }}>{children}</Box>
    </Drawer>
  );
}
